import { LifeCycleState } from '@carvana/merch-contracts';
import { useContext, useMemo } from 'react';
import TradeContext, { useSelectedTrade } from '~/context/common/TradeContext';
import useGetIsInTaxSavingRestrictedState from '~/hooks/common/selectors/useGetIsInTaxSavingRestrictedState';

export default function useTradeIncentiveTitleCopy(): string {
  const selectedTrade = useSelectedTrade();
  const { isTradeInApplied } = useContext(TradeContext);
  const isInTaxRestrictedState = useGetIsInTaxSavingRestrictedState();

  return useMemo(() => {
    if (!selectedTrade) return '';

    const incentiveValue = selectedTrade.tradeIncentive ?? 0;
    const taxSavingsValue = selectedTrade.maxTradeTaxSavings ?? 0;
    const totalSavings = incentiveValue + taxSavingsValue;
    const hasOnlyIncentive = Boolean(incentiveValue && !taxSavingsValue);
    const prefix = hasOnlyIncentive ? '' : 'up to';

    const isActive =
      selectedTrade.lifeCycleState === LifeCycleState.Active ||
      selectedTrade.lifeCycleState === LifeCycleState.Scheduled ||
      selectedTrade.lifeCycleState === LifeCycleState.AppliedToPurchase;

    const isExpired = selectedTrade.lifeCycleState === LifeCycleState.Expired;

    const formattedAmount = `${prefix ? `${prefix} ` : ''}$${Math.floor(
      isInTaxRestrictedState ? incentiveValue : totalSavings
    ).toLocaleString()}`;

    switch (true) {
      case isExpired:
        return `Refresh your offer to save ${formattedAmount}`;
      case isTradeInApplied && isActive:
        return `You'll save ${formattedAmount} with your trade-in`;
      case !isTradeInApplied && isActive:
        return `Include your trade-in to save ${formattedAmount}`;
      default:
        return '';
    }
  }, [isInTaxRestrictedState, isTradeInApplied, selectedTrade]);
}
